// BottomSheetShare.js
import React from 'react';
import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';

const BottomSheetShare = ({ open, onDismiss, shareUrl, title }) => {
  return (
    <BottomSheet open={open} onDismiss={onDismiss}>
      <div style={{ padding: '16px', textAlign: 'center' }}>
        <h2>Share Astroyami with Friends!</h2>
        <p>Invite friends to Astroyami for personalized AI astrological insights. Share the magic!</p>
        <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '16px', flexWrap: 'wrap' }}>
          <FacebookShareButton url={shareUrl} quote={title}>
            <FacebookIcon size={48} round />
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl} title={title}>
            <TwitterIcon size={48} round />
          </TwitterShareButton>
          <WhatsappShareButton url={shareUrl} title={title} separator=":: ">
            <WhatsappIcon size={48} round />
          </WhatsappShareButton>
          <LinkedinShareButton url={shareUrl} title={title}>
            <LinkedinIcon size={48} round />
          </LinkedinShareButton>
          <EmailShareButton url={shareUrl} subject={title} body={shareUrl}>
            <EmailIcon size={48} round />
          </EmailShareButton>

        </div>
      </div>
    </BottomSheet>
  );
};

export default BottomSheetShare;
